<div class="actions-container">
  <button mat-flat-button class="back-btn" (click)="goToEditBeneficiary()">VOLTAR</button>
</div>
<div class="dependent-container">
  <form [formGroup]="dependentForm" fxLayout="column" fxLayoutGap="10px" class="form-container">
    <div class="card-number-container" fxLayoutGap="10px">
      <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <span *ngIf="!!dependentForm.get('cardNumber').value"><b>Número do Cartão: </b>{{ dependentForm.get("cardNumber").value | cardNumberFormat }}</span>
        <mat-checkbox
          #enableDelivery
          fxFlex="40"
          formControlName="enableDelivery"
          labelPosition="after"
          matTooltip="Ao marcar esta opção, habilitara o Delivery no app Healthy IP.">
          Habilitar delivery
        </mat-checkbox>
      </div>
      <div *ngIf="!!dependentForm.get('cardNumber').value && isDependentCardBlocked()" class="card-status-container">
        <img src="./assets/icons/block-icon.svg" />
        <span>BLOQUEADO</span>
      </div>
    </div>
    <div>
      <div class="form-content" fxLayoutGap="10px">
        <mat-form-field fxFlex>
          <mat-label>CPF</mat-label>
          <input
            matInput
            formControlName="socialNumber"
            type="text"
            placeholder="CPF"
            (change)="onBeneficiaryInputChange()"
            (keyup)="searchBeneficiary()"
            [textMask]="{
              mask: socialNumberMask,
              guide: false,
              keepCharPositions: true
            }"
            [readonly]="!isNewDependent()"
            required />
          <mat-icon matSuffix class="visibility-icon" (click)="openVinculatedDialog()">info</mat-icon>
        </mat-form-field>
        <mat-form-field fxFlex="60">
          <mat-label>Nome</mat-label>
          <input
            [readonly]="!isEditableDependent()"
            matInput
            formControlName="name"
            type="text"
            placeholder="Nome"
            (change)="onBeneficiaryInputChange()"
            required />
        </mat-form-field>
      </div>
      <div class="form-content">
        <div fxFlex="100" fxLayoutGap="10px">
          <mat-form-field fxFlex="33">
            <mat-label>Data de Nascimento</mat-label>
            <input
              [readonly]="!isEditableDependent()"
              matInput
              formControlName="birthDate"
              type="text"
              placeholder="Data de Nascimento"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{ mask: dateMask, guide: false, keepCharPositions: true }" />
          </mat-form-field>
          <mat-form-field fxFlex="33" [style.pointer-events]="isEditableDependent() ? '' : 'none'">
            <mat-label>Sexo</mat-label>
            <mat-select matInput formControlName="gender" placeholder="Sexo" (selectionChange)="onBeneficiaryInputChange()" required>
              <mat-option [value]="0">{{ genderType.Male }}</mat-option>
              <mat-option [value]="1">{{ genderType.Female }}</mat-option>
              <mat-option [value]="2">{{ genderType.Unknow }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="33" [style.pointer-events]="isEditableDependent() ? '' : 'none'">
            <mat-label>Estado Civil</mat-label>
            <mat-select matInput formControlName="maritalStatus" placeholder="Estado Civil" (selectionChange)="onBeneficiaryInputChange()" required>
              <mat-option [value]="0">Casado</mat-option>
              <mat-option [value]="1">Solteiro</mat-option>
              <mat-option [value]="2">Divorciado</mat-option>
              <mat-option [value]="3">Viúvo</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxLayoutGap="10px">
          <mat-form-field fxFlex>
            <mat-label>Telefone</mat-label>
            <input
              [readonly]="!isEditableDependent()"
              matInput
              formControlName="telephone"
              type="text"
              placeholder="Telefone"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{
                mask: telephoneMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>
    
          <mat-form-field fxFlex>
            <mat-label>Celular</mat-label>
            <input
              [readonly]="!isEditableDependent()"
              matInput
              formControlName="mobile"
              type="text"
              placeholder="Celular"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{
                mask: mobileMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>
        </div>
        <div fxFlex="100" fxLayoutGap="10px">
          <div fxFlex="20">
            <mat-checkbox #addressDifferent formControlName="isNewAddress" abelPosition="after"> Endereço diferente do titular. </mat-checkbox>
          </div>
          <div *ngIf="addressDifferent.checked" fxFlex="100" fxLayoutGap="10px">
            <mat-form-field fxFlex="20">
              <mat-label>CEP</mat-label>
              <input
                matInput
                formControlName="zipCode"
                type="text"
                placeholder="CEP"
                (change)="onBeneficiaryInputChange()"
                (keyup)="getZipCode()"
                [textMask]="{
                  mask: zipCodeMask,
                  guide: false,
                  keepCharPositions: true
                }" />
            </mat-form-field>
    
            <mat-form-field fxFlex>
              <mat-label>Endereço</mat-label>
              <input matInput formControlName="street" type="text" placeholder="Endereço" (change)="onBeneficiaryInputChange()" />
            </mat-form-field>
    
            <mat-form-field fxFlex="15">
              <mat-label>Número</mat-label>
              <input matInput formControlName="number" type="text" placeholder="Número" (change)="onBeneficiaryInputChange()" />
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="addressDifferent.checked" fxFlex="100" fxLayoutGap="10px">
          <mat-form-field fxFlex="25">
            <mat-label>Complemento</mat-label>
            <input matInput formControlName="complement" type="text" placeholder="Complemento" (change)="onBeneficiaryInputChange()" />
          </mat-form-field>
    
          <mat-form-field fxFlex="15">
            <mat-label>Estado</mat-label>
            <mat-select matInput formControlName="region" placeholder="Estado" (selectionChange)="onStateInputChange()" required>
              <mat-option [value]="0">Selecione</mat-option>
              <mat-option *ngFor="let state of getStateList()" [value]="state">{{ state.getValue() }}</mat-option>
            </mat-select>
          </mat-form-field>
    
          <mat-form-field fxFlex>
            <mat-label>Cidade</mat-label>
            <mat-select matInput formControlName="city" placeholder="Cidade" (selectionChange)="onBeneficiaryInputChange()" required>
              <mat-option [value]="0">Selecione</mat-option>
              <mat-option *ngFor="let city of getCityList()" [value]="city">{{ city.getName() }}</mat-option>
            </mat-select>
          </mat-form-field>
    
          <mat-form-field fxFlex>
            <mat-label>Bairro</mat-label>
            <input matInput formControlName="district" type="text" placeholder="Bairro" (change)="onBeneficiaryInputChange()" required />
          </mat-form-field>
        </div>
        <div fxFlex="100" fxLayoutGap="10px">
          <mat-form-field fxFlex="70">
            <mat-label>E-mail</mat-label>
            <input
              [readonly]="!isEditableDependent()"
              matInput
              formControlName="email"
              type="text"
              placeholder="E-mail"
              (change)="onBeneficiaryInputChange()"
              [required]="needValidateEmail.checked" />
          </mat-form-field>
    
          <mat-checkbox
            #needValidateEmail
            fxLayoutAlign="center center"
            fxFlex="30"
            formControlName="needValidateEmail"
            labelPosition="after"
            matTooltip="Ao marcar esta opção, o beneficiário deverá utilizar o mesmo email informado aqui quando for acessar o aplicativo.">
            Validar email no próximo acesso
          </mat-checkbox>
        </div>
        <div  fxLayoutAlign="start center">
              <mat-checkbox formControlName="transactionPasswordRequired" fxLayoutAlign="center center"
              labelPosition="after"
              matTooltip="Requer senha para efetuar transações">
              Permitir segurança transacional?
            </mat-checkbox>
          </div>
      </div>
    </div>
  </form>
</div>
<div class="actions-container">
  <button
    mat-flat-button
    *ngIf="!isNewDependent() && hasAccessToBeneficiaryBlockCard() && !isDependentCardCancelled()"
    class="cancel-card-btn"
    (click)="onCancelDependentCard()">
    CANCELAR CARTÃO
  </button>
  <div class="inner-actions-container">
    <button
      mat-flat-button
      *ngIf="!isNewDependent() && hasAccessToBeneficiaryBlockCard() && !isDependentCardCancelled()"
      class="order-card-btn"
      (click)="onOrderDependentCard()">
      2° VIA DE CARTÃO
    </button>

    <button
      mat-flat-button
      *ngIf="hasAccessToBeneficiaryReactivateCard() && isEditableDependent() && isDependentActive() && isDependentCardBlocked()"
      class="unblock-card-btn"
      (click)="openCardUnblockDialog()">
      DESBLOQUEAR CARTÃO
    </button>

    <button
      mat-flat-button
      *ngIf="isEditableDependent() && isDependentActive() && isDependentCardBlocked()"
      class="beneficiary-usage-btn"
      (click)="exportBeneficiaryUsageFile()">
      GERAR CONSUMO
    </button>

    <button
      *ngIf="hasAccessToBeneficiaryBlockCard() && !isNewDependent() && isDependentActive() && !isDependentCardBlocked()"
      mat-flat-button
      class="block-card-btn"
      (click)="openCardBlockDialog()">
      BLOQUEAR CARTÃO
    </button>

    <button *ngIf="isNewDependent()" mat-flat-button class="save-btn" (click)="createDependent()">SALVAR</button>

    <button *ngIf="isEditableDependent() && !isNewDependent()" mat-flat-button class="save-btn" (click)="editDependent()">SALVAR</button>
  </div>
</div>
